var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlaviyoMasterChampion2026({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.776,
    height: 39.86,
    viewBox: "0 0 99.776 39.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-215.239 -310.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M82.133,0H47V38.86h98.329L132.062,19.43,145.329,0h-63.2Z",
    transform: "translate(168.739 311.402)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(222.181 318.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M271.146,166.334a1.193,1.193,0,0,1,.336-.837,1.179,1.179,0,0,1,.825-.361,1.215,1.215,0,0,1,.843.354,1.189,1.189,0,0,1,.354.843,1.167,1.167,0,0,1-.361.825,1.18,1.18,0,0,1-1.656-.006,1.172,1.172,0,0,1-.342-.819Zm9.3,2.524a.873.873,0,0,1,.935,1,6.764,6.764,0,0,1-.495,1.955c-.458,1.234-.935,2.64-1.448,4.247-.226-.776-.666-1.992-1.216-3.416l-.477-1.3a5.524,5.524,0,0,1-.4-1.656.764.764,0,0,1,.025-.312.745.745,0,0,1,.147-.275.7.7,0,0,1,.251-.189.772.772,0,0,1,.305-.073v-.232h-3.984v.232c.544.049.984.568,1.564,2.114l2.536,6.709a2.736,2.736,0,0,1,.226,1.21,2.78,2.78,0,0,1-.33,1.185,1.357,1.357,0,0,1-1.2.953c-.617,0-.935-.263-.935-.807,0-.214.409-.635.409-1.039a.833.833,0,0,0-.935-.831,1.168,1.168,0,0,0-.458.079,1.108,1.108,0,0,0-.385.263,1.166,1.166,0,0,0-.244.4,1.065,1.065,0,0,0-.055.458,2.16,2.16,0,0,0,2.884,1.827,2,2,0,0,0,.66-.409,3.906,3.906,0,0,0,.617-.965,4.06,4.06,0,0,0,.263-.654c.122-.3.2-.544.244-.7s.159-.422.287-.831l.287-.9q1.137-3.538,2.169-6.165a3.567,3.567,0,0,1,1.2-1.723,1.458,1.458,0,0,1,.458-.159v-.232h-2.9v.238Zm-27.8,8.328c-.513-.086-.953-.544-.953-1.515V164l-2.9.629v.251c.495-.055.99.385.99,1.32v9.471c0,.917-.495,1.442-.99,1.515l-.141.018a1.506,1.506,0,0,1-.733-.128,2.192,2.192,0,0,1-1-.917L245.575,174a2.47,2.47,0,0,0-1.2-1,2.433,2.433,0,0,0-1.558-.073l1.515-1.674a8.125,8.125,0,0,1,3.208-2.414v-.232h-3.324v.232c.855.336.813,1.075-.177,2.236l-2.126,2.487V164l-2.908.629v.251c.495,0,.99.495.99,1.356v9.434c0,1.039-.477,1.442-.99,1.515v.226h3.856v-.226c-.635-.086-.953-.568-.953-1.515v-1.741l.831-.9,2,3.293c.477.794.917,1.106,1.619,1.106h6.7v-.177S252.87,177.223,252.644,177.186Zm8.939.024v.232s-1.974.709-2.572-.495a2.47,2.47,0,0,1-.257-1.02,3.2,3.2,0,0,1-2.872,1.729c-1.424,0-2.45-.666-2.45-2.133a1.843,1.843,0,0,1,.318-1.039,3.4,3.4,0,0,1,1.833-1.32c.458-.171.855-.3,1.136-.385s.684-.177,1.137-.263l.892-.214v-1.057c0-1.76-.758-2.56-1.815-2.56a1.188,1.188,0,0,0-1.3,1.179c0,.348.251.855.251,1.234,0,.495-.44.855-1.057.855s-.917-.477-.917-1.112a2.141,2.141,0,0,1,.965-1.711,3.51,3.51,0,0,1,2.163-.739c2.475,0,3.55,1.173,3.593,3.752v3.929C260.649,176.324,260.716,177.351,261.584,177.21Zm-2.829-4.65c-.1.055-.348.141-.758.287l-.807.3c-.208.1-.354.177-.654.336a2.106,2.106,0,0,0-.617.44,1.979,1.979,0,0,0-.495,1.21c0,1.039.568,1.6,1.424,1.6a1.991,1.991,0,0,0,1.271-.507,1.634,1.634,0,0,0,.477-.617,1.733,1.733,0,0,0,.159-.764Zm32.6.47a4.581,4.581,0,0,1-1.32,3.281,4.289,4.289,0,0,1-1.436,1,4.339,4.339,0,0,1-4.864-1,4.825,4.825,0,0,1-.984-5.041,4.536,4.536,0,0,1,.978-1.5,4.214,4.214,0,0,1,1.43-1.014,4.294,4.294,0,0,1,4.864,1.014,4.475,4.475,0,0,1,.99,1.5,4.226,4.226,0,0,1,.342,1.76Zm-2.878-3.135a2.023,2.023,0,0,0-1.344-1.192c-1.088-.22-2.053.9-2.414,2.682a8.5,8.5,0,0,0-.11,2.426,6.711,6.711,0,0,0,.666,2.346,2.013,2.013,0,0,0,1.344,1.185c1.088.22,2.078-.947,2.438-2.75A7.35,7.35,0,0,0,288.481,169.9Zm-15.154,5.774v-7.057h-6.2v.214c.831.122,1.222.745.855,1.76-1.949,5.267-1.833,5.029-1.949,5.45-.122-.4-.4-1.4-.855-2.652s-.758-2.078-.88-2.45c-.477-1.46-.318-1.992.458-2.1v-.232H260.74v.232c.6.122,1.137.807,1.57,2.041l.617,1.6c.678,1.729,1.473,4.124,1.741,4.931H266c.428-1.247,2.157-6.263,2.383-6.758a3.932,3.932,0,0,1,.855-1.32h0a1.8,1.8,0,0,1,1.2-.5.85.85,0,0,1,.373.049.907.907,0,0,1,.525.513.961.961,0,0,1,.067.373v5.9c0,.984-.477,1.442-.971,1.515v.226h3.837v-.226C273.749,177.119,273.328,176.661,273.328,175.671Z",
    transform: "translate(-239 -164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M1093.734,164H1087v4.613h6.733l-1.332-2.3Z",
    transform: "translate(-1035.185 -164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(58.744 4.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1200.571,233.731v.324h-.037v-.324h-.135V233.7h.287v.031Z",
    transform: "translate(-1200.4 -233.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1206.353,234.054l-.122-.306v.306h-.031V233.7h.049l.122.312.122-.312h.049v.354h-.036v-.306l-.122.306Z",
    transform: "translate(-1205.846 -233.7)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "MASTER_CHAMPION",
    "data-name": "MASTER + CHAMPION",
    transform: "translate(0.04 24.16)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "ProximaNova-Regular, Proxima Nova",
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MASTER + CHAMPION"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlaviyoMasterChampion2026);
export default __webpack_public_path__ + "static/media/Klaviyo-Master-Champion-2026.2ff37d1d02b58598b160cfc5fe272c94.svg";
export { ForwardRef as ReactComponent };